<template>
  <FormItem v-bind="itemProps">
    <Select
      :value="value"
      @input="inputHandler"
      clearable
      v-bind="selectProps"
    >
      <Option v-for="rating in options" :key="rating.value" :value="rating.value">
        {{`${rating.label}（${rating.value}）`}}
      </Option>
    </Select>
  </FormItem>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    },
    selectProps: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    ...mapState('setting', [
			'ratings',
    ]),
    itemProps() {
      return {
        label: '设置评级',
        ...this.formItemProps,
      }
    },
    options() {
      const keys = Object.keys(this.ratings);
      keys.sort((x, y) => y - x);
      return keys.map(key => ({
        label: this.ratings[key],
        value: key,
      }))
    }
  },
  methods: {
    inputHandler(val) {
      this.$emit('input', val)
    }
  }
}
</script>